import { DataTool } from './DataTool'

interface Props {
  planOrganizationTaskId: number
  completed: boolean
  dueDate: Date
}
export const FocusStudentDataTool = (props: Props): JSX.Element => {
  const instructionsURL = 'https://www.gvsu.edu/autismcenter/2025-2026-rcn-application-and-contract-forms-595.htm'

  return (
    <DataTool
      planOrganizationTaskId={props.planOrganizationTaskId}
      completed={props.completed}
      title='Focus Student Data'
      dueDate={props.dueDate}
      instructionsUrl={instructionsURL}
      color='var(--green-500)'
      successMessage='Focus Student Data Updated'
      dataTestId='focusStudentDataTool'
    />
  )
}
